<template>
  <div class="main-banner" :class="isMobile ? '' : 'fill-section-1080'">
    <img class="img-cover" :src="bannerUrl" :alt="bannerName" @load="pageLoad" @error="pageLoad"/>
    <div class="banner-text fade-up" 
      :class="[isMobile ? mobileFontColor : fontColorType,
              isMobile && bannerName === 'BadainJaran' ? 'badain-jaran' : '']">
      <h2 class="banner-title" v-html="title"></h2>
      <p class="banner-sub-title" v-html="subTitle"></p>
    </div>
  </div>
</template>

<script>
import { fadeAnimate, destroyFadeAnimate } from '../utils/animation.js'
export default {
  name: 'CarMainBanner',
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
    bannerName: {
      type: String,
      required: true
    },
    bannerUrl: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      required: true
    },
    fontColorType: {
      type: String,
      default: 'dark'
    },
    mobileFontColor: {
      type: String,
      default: 'dark'
    },
  },
  mounted() {
    fadeAnimate();
  },
  beforeDestroy() {
    destroyFadeAnimate();
  },
  data() {
    return {

    }
  },
  methods: {
    pageLoad() {
      this.$emit('pageLoad');
    }
  }
}
</script>

<style lang="less" scoped>
.main-banner {
  .banner-text {
    position: absolute;
    top: 5.86vw;
    left: 4.88vw;
    .banner-title {
      font-size: 84px;
      font-size: clamp(48px, 4.35vw, 84px);
      font-weight: @fw1;
      font-family: 'TsangerYunHei', sans-serif;
    }
    .banner-sub-title {
      font-size: clamp(18px, 1.67vw, 32px);
      font-weight: @fw2;
      font-family: 'TsangerYunHei', sans-serif;
      margin-top: 8px;
    }
    &.dark {
      .banner-title {
        color: #222222;
      }
      .banner-sub-title {
        color: #666666;
      }
    }
    &.light {
      .banner-title {
        color: #ffffff;
      }
      .banner-sub-title {
        color: rgba(255, 255, 255, 0.7);
      }
    }
  }
}
@media (max-width: @mobile-width) {
  .main-banner {
    .banner-text {
      position: absolute;
      top: 33.33vw;
      left: 5.33vw;
      right: 17vw;
      font-weight: @fw2;
      .banner-title {
        font-size: 12.8vw;
        line-height: 1.1;
      }
      .banner-sub-title {
        font-size: 6.4vw;
      }
      &.dark {
        .banner-title {
          color: #464646;
        }
        .banner-sub-title {
          color: #464646;
        }
      }
      &.light {
        .banner-title {
          color: #ffffff;
        }
        .banner-sub-title {
          color: #ffffff;
        }
      }
    }
    .badain-jaran {
      left: 17.06vw;
      right: 17.06vw;
      text-align: center;
      text-align: justify;
      text-align-last: justify;
      .banner-title {
        font-size: 12.8vw;
      }
    }
  }
}
</style>